export default __webpack_public_path__ + "static/media/Timesup_color.03b7e859.svg";